export const RETURN_TO_QUERY_PARAM = 'returnTo'

export function buildRouteWithReturnTo(path: string, returnTo?: string) {
  if (!returnTo) {
    return path
  }

  const [pathname, search = ''] = path.split('?')
  const params = new URLSearchParams(search)
  params.set(RETURN_TO_QUERY_PARAM, returnTo)
  const serialized = params.toString()

  return serialized ? `${pathname}?${serialized}` : pathname
}

export function resolveSafeInternalReturnTo(value: string | null | undefined) {
  const trimmed = value?.trim()
  if (!trimmed || !trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return null
  }

  try {
    const url = new URL(trimmed, 'https://app.epicgrowth.local')
    if (url.origin !== 'https://app.epicgrowth.local') {
      return null
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}
